export default "__VITE_ASSET__BUSEHLWw__"